export interface ContactEmailData {
  yourName: string
  email: string
  phone: string
  whatsapp?: string
  message: string
  countryCode: string
  callingCode: string
}

export function buildContactEmailHtml(data: ContactEmailData): string {
  const { yourName, email, phone, whatsapp, message, countryCode, callingCode } = data

  return `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Thông tin liên hệ</title>
      <style>
        body { font-family: Arial, Helvetica, sans-serif; color: #1f2937; background: #f9fafb; margin: 0; padding: 24px; }
        .card { max-width: 640px; margin: 0 auto; background: #ffffff; border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; }
        .header { background: #0B9444; color: #ffffff; padding: 16px 24px; font-size: 18px; font-weight: 700; }
        .content { padding: 24px; }
        .row { display: flex; margin-bottom: 12px; }
        .label { width: 180px; color: #6b7280; font-weight: 600; }
        .value { flex: 1; color: #111827; }
        .message { white-space: pre-wrap; background: #f3f4f6; padding: 12px; border-radius: 8px; border: 1px solid #e5e7eb; }
        .footer { padding: 16px 24px; color: #6b7280; border-top: 1px solid #e5e7eb; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="card">
        <div class="header">Thông tin liên hệ mới</div>
        <div class="content">
          <div class="row"><div class="label">Họ và tên</div><div class="value">${escapeHtml(yourName)}</div></div>
          <div class="row"><div class="label">Email</div><div class="value">${escapeHtml(email)}</div></div>
          <div class="row"><div class="label">Số điện thoại</div><div class="value">+${escapeHtml(
            callingCode,
          )} ${escapeHtml(phone)}</div></div>
          ${
            whatsapp
              ? `<div class="row"><div class="label">Số WhatsApp</div><div class="value">${escapeHtml(
                  whatsapp,
                )}</div></div>`
              : ""
          }
          <div class="row"><div class="label">Quốc gia</div><div class="value">${escapeHtml(countryCode)}</div></div>
          <div class="row" style="align-items:flex-start"><div class="label">Tin nhắn</div><div class="value"><div class="message">${escapeHtml(
            message,
          )}</div></div></div>
        </div>
        <div class="footer">Email này được gửi tự động từ website CaoCao Adventures.</div>
      </div>
    </body>
  </html>
  `
}

function escapeHtml(input: string): string {
  return input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;")
}
